(function () {
    'use strict';

    angular.module("imApp").factory("custGrpService", ['$ihttp', function ($ihttp) {
		let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1009,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1010,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
